/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots3HCircleIcon64Regular = forwardRef('UiMenuDots3HCircleIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M44 35a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" }),
        React.createElement("path", { d: "M35 32a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" }),
        React.createElement("path", { d: "M20 35a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32 6C17.64 6 6 17.64 6 32s11.64 26 26 26 26-11.64 26-26S46.36 6 32 6ZM9 32C9 19.297 19.297 9 32 9s23 10.297 23 23-10.297 23-23 23S9 44.703 9 32Z" })));
});
